module.exports = __webpack_public_path__ + "static/media/filter-feature-drugs.24f90d78.svg";